import { MountingType } from '@/services/models/BackupHeaterCharacteristic'
import { FuelType } from '@/helper/Types'

export class BackupHeaterFilter {
  mounting?: MountingType
  boilerType?: BoilerType
  fuelType?: FuelType
}

export enum BoilerType {
  COMBI_BOILER = 'combi_boiler',
  SYSTEM_BOILER = 'system_boiler'
}
